
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic05On as ObiLogic05OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-05-on.js';
 
 
 

 
 export const ObiLogic05On = createComponent({
   react: React,
   tagName: 'obi-logic-05-on',
   elementClass: ObiLogic05OnElement,
   events: {
     
   }
  });
 
 